import { lazy } from 'react';

const RELOAD_KEY = 'chunk_reload';

function lazyWithRetry(importFn) {
  return lazy(() =>
    importFn().catch(() => {
      const lastReload = sessionStorage.getItem(RELOAD_KEY);
      const now = Date.now();
      if (!lastReload || now - Number(lastReload) > 10000) {
        sessionStorage.setItem(RELOAD_KEY, String(now));
        window.location.reload();
      }
      return new Promise(() => {});
    }),
  );
}

export default lazyWithRetry;
